"use client";

import { useSearchParams } from "next/navigation";
import { useEffect } from "react";

/**
 * Captures a `?ref=<id>` referral on the landing page into the `referer_id`
 * cookie (30-day expiry), then strips it from the URL — mirrors the legacy
 * landing behavior. The signup form later reads this same cookie
 * (`features/auth/components/signup-form.tsx`) to attribute the referral.
 *
 * Renders nothing; it's a mount-time side effect wrapped in <Suspense> by the
 * page (useSearchParams requires a Suspense boundary).
 */
export function ReferralCapture() {
  const params = useSearchParams();

  useEffect(() => {
    const ref = params.get("ref");
    if (!ref) return;

    const expires = new Date(
      Date.now() + 30 * 24 * 60 * 60 * 1000,
    ).toUTCString();
    document.cookie = `referer_id=${encodeURIComponent(ref)}; expires=${expires}; path=/`;

    // Drop `ref` from the visible URL without a navigation.
    const url = new URL(window.location.href);
    url.searchParams.delete("ref");
    window.history.replaceState({}, document.title, url.toString());
  }, [params]);

  return null;
}
